import comm_data from '../comm_data';
import api_TS from './api_TS';
import './dataHandler_dateFormat';

export default class ApiGo_TS {
  // NOTE: Get users
  /**
   * // ✎NOTE: ---------〖GET - 查目前照護者資訊〗---------
   *
   */
  static async getUsers<Tresponse>(): Promise<Tresponse> {
    const apiParas = {
      type: 'get_users',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }
  static async getVersion<Tresponse>(): Promise<Tresponse> {
    const apiParas = {
      type: 'get_version',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }
  static getAlert<Tresponse>(_id: number, _date: string, _timestamp: string): Promise<Tresponse> {
    /**
     * ALL: 00:00:00~23:59:59
     * GS: 00:00:00~07:59:59
     * MS: 08:00:00~15:59:59
     * NS: 16:00:00~23:59:59
     */
    // http://192.168.0.50/alert/20/2021-08-19/ALL
    const apiParas = {
      type: 'alert',
      resident_id: _id || '19',
      date: _date, // 有資料
      // date: _date || (new Date).Format("yyyy-MM-dd"), // 有資料
      // date: (new Date).Format("yyyy-MM-dd"), // 當天日期
      timestamp: _timestamp || 'ALL',
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.date}/${apiParas.timestamp}`;

    return api_TS(_url, 'GET', apiParas.type);
  }
  /**
   * // ✎NOTE: ---------〖GET - 查所有Line notify的token〗---------
   *
   */
  static getline_token<TResponse>(): Promise<TResponse> {
    // http://192.168.0.50:8080/token
    const apiParas = {
      type: 'token',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }

  /**
   * // ✎NOTE: ---------〖GET - 重啟line notify service〗---------
   *
   */
  static getLineNotify_start<TResponse>(): Promise<TResponse> {
    // http://192.168.0.99:8080/line_notify_start
    const apiParas = {
      type: 'line_notify_start',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }
  // ✎NOTE: ---------〖POST - line notify post 新群組〗---------
  // 首頁圖片 + icon
  static postline_notify_post<TResponse>(user_id: number, _token: string, _title: string): Promise<TResponse> {
    // http://192.168.0.186:8080/line_notify_post?user_id=1&line_token=1233&title=1233
    const apiParas = {
      type: 'line_notify_post',
      data: {
        // title:_title,
        // user_id:user_id,
        // token:_token
      },
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}?user_id=${user_id}&line_token=${_token}&title=${_title}`;

    return api_TS(_url, 'POST', apiParas.type, JSON.stringify(apiParas.data));
  }
  // ✎NOTE: ---------〖PUT - line notify 修改〗---------
  // 首頁圖片 + icon
  static putline_notify_group_title(user_id: number, _id: number, _token: string, _title: string) {
    // http://192.168.0.99:8080/line_notify_group_title?role=a&email=a&token=a&title=a
    const apiParas = {
      type: 'line_notify_group_title',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}?user_id=${user_id}&id=${_id}&token=${_token}&title=${_title}`;

    return api_TS(_url, 'PUT', apiParas.type, JSON.stringify(apiParas.data));
  }
  /**
   * // ✎NOTE: ---------〖GET - 抓活動力資訊〗---------
   *
   */
  static getMobilityData<TResponse>(_id: number, _time: string): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityData/281/2024-03-26
    const apiParas = {
      type: 'get_mobilityData',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${_id}/${_time}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }
  /**
   * // ✎NOTE: ---------〖GET - 抓活動力資訊_多日〗---------
   *
   */
  static getMobilityDataForDays<TResponse>(_id: number, _date: any): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityData/281/2024-03-26
    const { fromDate, endDate } = _date;
    const apiParas = {
      type: 'get_mobilityData_forDays',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${_id}/${fromDate}/${endDate}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }

  // static getMobilityEstimateForDays<TResponse>(_resident_id: number, _date: any): Promise<TResponse> {
  //   // http://192.168.0.50/get_Mobility_estimate/20/2021-08-06/2021-08-06
  //   const { fromDate, endDate } = _date;
  //   const apiParas = {
  //     type: 'get_Mobility_estimate_forDays',
  //     resident_id: _resident_id || '20', // 有資料 id(床-無線版)
  //     date: _date || '2021-08-06',
  //     // to_date: _to_date || (new Date).Format("yyyy-MM-dd"), // 當天日期
  //   };
  //   return api_TS(`${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${fromDate}/${endDate}`, 'GET', apiParas.type);
  // }

  static getMobilityRotateFS<TResponse>(_id: number, _time: string): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityDataRotation/281/2024-03-26
    const apiParas = {
      type: 'mobilityDataRotation',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${_id}/${_time}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }

  static getMobilityFsensor_ByResident<TResponse>(_resident_id: number, _date: string): Promise<TResponse> {
    // http://192.168.0.50/get_Mobility_FSensor_by_resident/20/2021-08-06/2021-08-06
    const apiParas = {
      type: 'get_Mobility_FSensor_by_resident',
      resident_id: _resident_id || '20', // 有資料 id(床-無線版)
      date: _date || '2021-08-06',
      // to_date: _to_date || (new Date).Format("yyyy-MM-dd"), // 當天日期
    };
    return api_TS(`${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.date}`, 'GET', apiParas.type);
  }
  static getAlertStateEndTime<TResponse>(_resident_id: number): Promise<TResponse> {
    // 'http://25.4.116.97:8080/alert_start_end_time/334'
    const apiParas = {
      type: 'alert_start_end_time',
      resident_id: _resident_id || '20', // 有資料 id(床-無線版)
    };
    return api_TS(`${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}`, 'GET', apiParas.type);
  }
  static getMobilityEstimate<TResponse>(_resident_id: number, _date: string): Promise<TResponse> {
    // http://192.168.0.50/get_Mobility_estimate/20/2021-08-06/2021-08-06
    const apiParas = {
      type: 'get_Mobility_estimate',
      resident_id: _resident_id || '20', // 有資料 id(床-無線版)
      date: _date || '2021-08-06',
      // to_date: _to_date || (new Date).Format("yyyy-MM-dd"), // 當天日期
    };
    return api_TS(`${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.date}`, 'GET', apiParas.type);
  }
  static getMobilityEstimateForDays<TResponse>(_resident_id: number, _date: any): Promise<TResponse> {
    // http://192.168.0.50/get_Mobility_estimate/20/2021-08-06/2021-08-06
    const { fromDate, endDate } = _date;
    const apiParas = {
      type: 'get_Mobility_estimate_forDays',
      resident_id: _resident_id || '20', // 有資料 id(床-無線版)
      date: _date || '2021-08-06',
      // to_date: _to_date || (new Date).Format("yyyy-MM-dd"), // 當天日期
    };
    return api_TS(`${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${fromDate}/${endDate}`, 'GET', apiParas.type);
  }
  /**這是舊版的
   * // ✎NOTE: ---------〖GET - 抓活動力數據〗---------
   *
   */
  static getMobilityEstimateOld<TResponse>(_resident_id: number, _date: string): Promise<TResponse> {
    // http://192.168.0.50/get_Mobility_estimate/20/2021-08-06/2021-08-06
    const apiParas = {
      type: 'get_Mobility_estimate_old',
      resident_id: _resident_id || '20', // 有資料 id(床-無線版)
      date: _date || '2021-08-06',
      // to_date: _to_date || (new Date).Format("yyyy-MM-dd"), // 當天日期
    };
    return api_TS(`${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.date}`, 'GET', apiParas.type);
  }
  /**
   * // ✎NOTE: ---------〖GET - 抓舊版活動力資訊(第七項指標)〗---------
   *
   */
  static getMobilityMovenment<TResponse>(_id: number, _time: string): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityData/281/2024-03-26
    const apiParas = {
      type: 'get_mobilityMovement',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${_id}/${_time}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }

  static getMobilityMovenmentForDays<TResponse>(_id: number, _date: any): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityData/281/2024-03-26
    const { fromDate, endDate } = _date;
    const apiParas = {
      type: 'get_mobilityMovement_forDays',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${_id}/${fromDate}/${endDate}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }
  /**
   * // ✎NOTE: ---------〖GET - 抓舊版活動力資訊(第七項指標)〗---------
   *
   */
  static getOldMobilityMovenment<TResponse>(_id: number, _time: string): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityData/281/2024-03-26
    const apiParas = {
      type: 'get_mobilityMovement_old',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${_id}/${_time}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }
  /** 這是舊版的
   * // ✎NOTE: ---------〖GET - 抓活動力資訊〗---------
   *
   */
  static getMobilityOlDData<TResponse>(_id: number, _time: string): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityData/281/2024-03-26
    const apiParas = {
      type: 'get_mobilityOlDData',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${_id}/${_time}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }

  /**
   * // ✎NOTE: ---------〖GET - 功能開關切換〗---------
   *
   */
  static getFeatureStatus<TResponse>(): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityData/281/2024-03-26
    const apiParas = {
      type: 'get_feature_status_list',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}`;
    return api_TS(_url, 'GET', apiParas.type, JSON.stringify(apiParas.data));
  }
  /**
   * // ✎NOTE: ---------〖DELETE - 刪除受護者resident assign id〗---------
   *
   */
  static deleteResidentAssignId<TResponse>(_id: number, status: boolean): Promise<TResponse> {
    // http://192.168.0.99:8080/mobilityData/281/2024-03-26
    const apiParas = {
      type: 'remove_resident_from_user',
      data: {},
    };
    let _url: string = `${comm_data.API_HOST}/${apiParas.type}/${_id}?leave=${status}`;
    return api_TS(_url, 'DELETE', apiParas.type, JSON.stringify(apiParas.data));
  }
}